import { Center, HStack, Heading, Modal, ModalContent, Spinner, Stack, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Text } from '@chakra-ui/react'
import { Sandbox } from "../../models/sandbox";
import { useFetch } from "../../contexts/FetchContext";
import { useFormKeyBindings } from "../../components/Helpers/useFormKeyBindings";
import { ItemModal } from "../../components/ItemModal";

export const SandboxModal = () => {
  const [sandBox, setSandBox] = useState<Sandbox>()
  const navigate = useNavigate();
  const { backend } = useFetch();
  const { id } = useParams();
  const location = useLocation();

  const onClose = () => {
    navigate("/sandboxes" + location.search);
  };

  /* Get sandBox */
  useEffect(() => {
    if (id) {
      refetch()
    } else {
      console.debug('Could not find sandbox id')
      onClose()
    }
  }, [id]);

  const refetch = () => {
    backend.sandboxes.getById(parseInt(id!))
      .then((data) => {
        setSandBox(data);
      }).catch((e) => {
        console.error(e)
        onClose()
      })
  }

  const handleRent = () => {
    if (sandBox) {
      const path = `/sandboxes/${sandBox.id}/${sandBox.rentStatus?.status !== undefined ? 'return' : 'rent'}`;
      navigate(path, { state: { previousLocation: location.pathname } });
    }
  };

  const handleEdit = () => {
    if (sandBox) {
      navigate(`/sandboxes/${sandBox.id}/edit`, { state: { previousLocation: location.pathname } });
    }
  };

  const handleDelete = () => {
    if (sandBox) {
      const isDeleted = sandBox.deleted && new Date(sandBox.deleted) > new Date(0);
      const path = `/sandboxes/${sandBox.id}/${isDeleted ? 'restore' : 'delete'}`;
      navigate(path, { state: { previousLocation: location.pathname } });
    }
  };

  useFormKeyBindings({
    handleClose: onClose,
    handleRent,
    handleEdit,
    handleDelete
  });

  return (
    <Modal isCentered={true} isOpen={true} onClose={onClose} size='3xl'>
      {sandBox ?
          <ItemModal headerLine2={sandBox.name} item={sandBox} onClose={onClose} >
          <VStack spacing={8} align='flex-start'>
            <Stack direction='column' flex={1} align='flex-start' spacing={4}>
              <Heading size='md'>Info</Heading>
              <HStack align='flex-start' wrap='wrap' gap={10}>
                <VStack align='flex-start' spacing={0}>
                  <Heading size='sm'>Alias</Heading>
                  <Text size='sm'>{sandBox.alias}</Text>
                </VStack>
              </HStack>
              <HStack align='flex-start' wrap='wrap' gap={10}>
                <VStack align='flex-start' spacing={0}>
                  <Heading size='sm'>Mail</Heading>
                    <Text size='sm'>{sandBox.mail}</Text>
                </VStack>
              </HStack>
            </Stack>
            {sandBox.description &&
              <VStack flex={1} align='flex-start' spacing={2} whiteSpace='pre-line'>
                <Heading size='md'>Description</Heading>
                <Text size='sm'>{sandBox.description}</Text>
              </VStack>
            }
            {sandBox.rentStatus?.note &&
              <VStack flex={1} align='flex-start' spacing={2}>
                <Heading size='md'>Notes</Heading>
                <Text size='sm' whiteSpace='pre-line'>
                  {sandBox.rentStatus.note}
                </Text>
              </VStack>
            }
          </VStack>
        </ItemModal>
        :
        <ModalContent bg="transparend" shadow="none">
          <Center>
            <Spinner size='lg' />
          </Center>
        </ModalContent>
      }
    </Modal>
  )
}
